import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=5631b06c&"
import script from "./Reg.vue?vue&type=script&lang=js&"
export * from "./Reg.vue?vue&type=script&lang=js&"
import style0 from "./Reg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
